export const loginGetters = {
  /* ****************A*I********************* */

  getIsAuthenticated(state) {
    return state.isAuthenticated
  },
  getIsInitialized(state) {
    return state.isInitialized
  },
  getIsLoggedIn(state) {
    return state.isLoggedIn
  },
  getUserName(state) {
    return state.userName
  },
  getUserEmail(state) {
    return state.userEmail
  },
  getLoginType(state) {
    return state.loginType
  },
  getMicrosoftLogin(state) {
    return state.microsoftLogin ?? localStorage.getItem('microsoftLogin') === 'true'
  },
  getGoogleLogin(state) {
    return state.googleLogin ?? localStorage.getItem('googleLogin') === 'true'
  },
  getAdminuserInfo(state) {
    return state.adminuserInfo || sessionStorage.getItem('adminuserinfo')
  },
  getInteractionInProgress(state) {
    return state.interactionInProgress
  }
}
